// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import { Roles } from 'services/user-context/types';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { useGetUserContextQuery } from 'services/user-context/user-context-api';
import { environment } from '../../../environments/environment';

const { serverConfig = {} } = window;
const { Version = {} } = serverConfig;

const Wrapper = styled.footer`
  background-color: ${(props) => props.theme.colors.brandBlue};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  height: 27px;
`;

const ApplicationVersion = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Footer = () => {
  const { data: userContext } = useGetUserContextQuery();
  return (
    <Wrapper>
      <ApplicationVersion>
        <span>
          Version: {Version.MajorVersionNr}.{Version.MinorVersionNr}
          {Version.HotFixVersionNr ? '.' + Version.HotFixVersionNr : ''}
          {Version.AdditionalComment ? ' - ' + Version.AdditionalComment : ''}
        </span>
        {environment.showDevInfo && (
          <Popover
            content={
              <div>
                {Object.entries(userContext?.roles as Roles).map(
                  ([key, value]) => (
                    <li key={key} style={{ display: 'block' }}>
                      {key}: {value ? 'Yes' : 'No'}
                    </li>
                  )
                )}
              </div>
            }
            title="Development Info"
            trigger="click"
          >
            <InfoCircleOutlined style={{ marginLeft: '6px' }} />
          </Popover>
        )}
      </ApplicationVersion>
    </Wrapper>
  );
};

export default Footer;
